import { configureStore } from '@reduxjs/toolkit'
import signUpSlice from './slices/signUp';
import loaderSlice from "./slices/loader"
import authReducer from '../src/slices/authSlice';
import productReducer from '../src/slices/productSlice';


// reducer function

const reducer = {
    auth: authReducer,
    signup: signUpSlice,
    loader: loaderSlice,
    products: productReducer

}



// store configure function

const store = configureStore({
    reducer: reducer,
    devTools: true,
})

export default store;